"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const dateformat_1 = require("../../../common/js/helper/dateformat");
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const LocalStorageKeys_1 = __importDefault(require("../../enums/LocalStorageKeys"));
const ReturnStore_1 = __importDefault(require("../../stores/ReturnStore"));
const TableTileReturn_1 = __importDefault(require("../TableTileReturn"));
const AssetsReturnsTableExpandedItem_1 = __importDefault(require("./AssetsReturnsTableExpandedItem"));
const ReturnReasonObservableComponent_1 = __importDefault(require("./ReturnReasonObservableComponent"));
const ReturnReasonOtherObservableComponent_1 = __importDefault(require("./ReturnReasonOtherObservableComponent"));
const ToggleObservedComponent = (0, mobx_react_1.observer)(({ returnObject }) => (react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-return-table-input__checkbox-label" },
    react_1.default.createElement("input", { disabled: returnObject.isInReturnProcess, type: "checkbox", className: "custom-control-input", checked: ReturnStore_1.default.isSelectedReturn(returnObject.id), onClick: () => {
            ReturnStore_1.default.toggleReturn(returnObject.id);
        } }),
    react_1.default.createElement("span", { className: "custom-control-label" }))));
const AssetsReturns = () => {
    let contextReactionDisposer;
    const columns = [
        {
            name: '',
            cell: (returnObject) => react_1.default.createElement(ToggleObservedComponent, { returnObject: returnObject }),
            sortable: true,
            minWidth: '3rem',
            maxWidth: '3rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.amount.column_name'),
            selector: (returnObject) => returnObject.amount,
            sortable: true,
            minWidth: '5rem',
            maxWidth: '5rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.part.column_name'),
            selector: (returnObject) => returnObject.part,
            sortable: true,
            minWidth: '4rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.designation.column_name'),
            selector: (returnObject) => returnObject.designation ?? '',
            sortable: true,
            minWidth: '6rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.replacement_order.column_name'),
            cell: (returnObject) => (react_1.default.createElement("p", null,
                (0, translation_1.t)('myassets.returns.table.order_no_label', { orderNumber: returnObject.orderNumber }),
                react_1.default.createElement("br", null),
                (0, translation_1.t)('myassets.returns.table.serial_no_label', { serialNumber: returnObject.serialNumber }),
                react_1.default.createElement("br", null),
                (0, dateformat_1.getDateFormat)(returnObject.returnOrderDate))),
            sortable: true,
            minWidth: '5rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.return_order.column_name'),
            cell: (returnObject) => (react_1.default.createElement("p", null,
                (0, translation_1.t)('myassets.returns.table.order_no_label', { orderNumber: returnObject.orderNumber }),
                react_1.default.createElement("br", null),
                (0, dateformat_1.getDateFormat)(returnObject.returnOrderDate))),
            sortable: true,
            minWidth: '5rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.return_reason.column_name'),
            cell: (returnObject) => react_1.default.createElement(ReturnReasonObservableComponent_1.default, { returnObject: returnObject }),
            sortable: true,
            minWidth: '7.25rem',
        },
        {
            name: (0, translation_1.t)('myassets.returns.table.return_reason_other.column_name'),
            cell: (returnObject) => react_1.default.createElement(ReturnReasonOtherObservableComponent_1.default, { returnObject: returnObject }),
            sortable: true,
            minWidth: '7.25rem',
        },
    ];
    (0, react_1.useEffect)(() => {
        document.title = (0, translation_1.t)('myassets_subpage_title', { title: (0, translation_1.t)('myassets.offer.title') });
        contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => ReturnStore_1.default.readReturns(), { fireImmediately: true });
        return () => {
            contextReactionDisposer?.();
        };
    }, []);
    return (react_1.default.createElement("section", { className: "znd-offers-table" }, ReturnStore_1.default.isLoading ? (react_1.default.createElement(LoadingSpinner_1.default, { center: true })) : (react_1.default.createElement(TableTileReturn_1.default, { columns: columns, expandableComponent: AssetsReturnsTableExpandedItem_1.default, expandableRowsHideExpander: false, data: ReturnStore_1.default.returns, title: "Returns", localStorageKey: LocalStorageKeys_1.default.addressesSort }))));
};
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AssetsReturns));
